import { useEffect, useState } from 'react';

/** The clock, re-read every `ms`; a page that shows minutes needs no more than every few seconds. */
export function useNow(ms: number): number {
  const [now, setNow] = useState(() => Date.now());
  useEffect(() => {
    const t = setInterval(() => setNow(Date.now()), ms);
    return () => clearInterval(t);
  }, [ms]);
  return now;
}

/** Whole days, hours, minutes and seconds in a span of seconds. */
export function splitSeconds(total: number) {
  const s = Math.max(0, Math.floor(total));
  return {
    days: Math.floor(s / 86400),
    hours: Math.floor((s % 86400) / 3600),
    minutes: Math.floor((s % 3600) / 60),
    seconds: s % 60,
  };
}
